import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, defaultValues } from "./schema";
import { handleMessageError, handleMessageSuccess, handleMessageWarning } from "../../../../components/toast";
import { getReturnUpdated } from "../../../../util/libObject";
import LibBoolean from "../../../../util/libBool";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	//#region useForm
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: defaultValues,
	});
	//#endregion

	//#region Controle de estado
	const [isInsert, setIsInsert] = useState(false);
	const [loading, setLoading] = useState(false);
	//#endregion

	//#region Fetch para popular formulário
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetchData(id);
			} else {
				reset(defaultValues);
			}

			setIsInsert(id === 0);
		} else {
			if (setSelectData) setSelectData({});
			reset(defaultValues);
		}
	}, [isOpenModalRegister, selectedData]);

	const fetchData = async (id) => {
		try {
			setLoading(true);
			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = Array.isArray(response.data) ? response.data[0] : response.data;

				Object.keys(data).forEach((field) => {
					if (field === "ativo") {
						setValue(field, LibBoolean.strToBoolean(data[field]));
					} else {
						setValue(field, data[field]);
					}
				});
			}
		} catch (error) {
			handleMessageError(error.message || error);
			handleCloseModalRegister();
		} finally {
			setLoading(false);
		}
	};
	//#endregion

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			const newAtivo = LibBoolean.booleanToStr(data.ativo);
			const response = await insert({ ...data, ativo: newAtivo });

			const returned = getReturnUpdated(response);
			const currentId = returned?.id_taxa_entrega ?? 0;
			const oldID = data.id_taxa_entrega;

			await reloadData(oldID, currentId);

			handleMessageSuccess("Registro salvo com sucesso.");
			reset(defaultValues);
			handleCloseModalRegister();
		} catch (error) {
			handleMessageWarning("Não foi possível salvar: " + (error.message || error));
		}
	};
	//#endregion

	//#region Fechar modal
	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};
	//#endregion

	return {
		//useForm
		register,
		control,
		errors,
		isSubmitting,
		setValue,
		handleSubmit,

		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//variables
		isInsert,
		loading,
	};
};
